export default "__VITE_ASSET__1b6fe116__"